import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../store'
import * as api from '@/apis/aipass'

export const fetchFacilityBasicInfo = createAsyncThunk(
  'hotel/fetchFacilityBasicInfo',
  async (arg: { isForce?: boolean } | undefined, { rejectWithValue }) => {
    try {
      return await api.fetchFacilityBasicInfo()
    } catch (error) {
      return rejectWithValue(error)
    }
  },
  {
    dispatchConditionRejection: true,
    condition: (arg, { getState }) => {
      if (arg?.isForce) {
        return true
      }
      const { hotelFacility } = getState() as RootState
      if (hotelFacility.isFetched) {
        return false
      }
      return !hotelFacility.loading
    },
  },
)
